import React from 'react';
import { useStyletron } from 'baseui';
import { ModalActionsProps } from './modal-actions-props.interface';
import { ButtonV2 } from '../button';

export const ModalActions = ({
  primaryActionLabel,
  primaryActionOnClick,
  handleModalClose,
  disablePrimaryAction = false,
  hasBottomRadius = true,
  secondaryActionLabel = 'Cancel',
  isLoading,
  loadingText,
}: ModalActionsProps) => {
  const [, theme] = useStyletron();
  return (
    <div
      className="flex justify-center w-full p-3"
      style={{
        background: theme.colors.backgroundPrimary,
        borderBottomLeftRadius: hasBottomRadius ? theme.borders.radius300 : '0',
        borderBottomRightRadius: hasBottomRadius
          ? theme.borders.radius300
          : '0',
      }}
    >
      <ButtonV2
        variant="default"
        size="small"
        variantStyle="primary"
        onClick={primaryActionOnClick}
        disabled={disablePrimaryAction}
        loading={isLoading}
        loadingText={loadingText}
      >
        {primaryActionLabel}
      </ButtonV2>
      <div className="ml-3">
        <ButtonV2
          variant="default"
          size="small"
          variantStyle="primary"
          onClick={handleModalClose}
          disabled={false}
          loadingText={loadingText}
        >
          {secondaryActionLabel}
        </ButtonV2>
      </div>
    </div>
  );
};
